import styled from 'styled-components';

import { mediaQueryDesktopMin, mediaQueryMobileMin } from 'styles';

export const BreadCrumbsWrapper = styled.div`
  width: 100%;
  margin: 0 auto;
  padding: 16px;

  @media all and ${mediaQueryMobileMin} {
    padding: 24px 16px;
  }

  @media all and ${mediaQueryDesktopMin} {
    width: 1008px;
  }
`;

export default BreadCrumbsWrapper;
